import { render } from "./_Footer.vue?vue&type=template&id=93706f48&scoped=true&lang=en"
import script from "./_Footer.vue?vue&type=script&lang=js"
export * from "./_Footer.vue?vue&type=script&lang=js"

import "./_Footer.vue?vue&type=style&index=0&id=93706f48&scoped=true&lang=scss"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93706f48"]])

export default __exports__